import { render } from "./SurveyFilters.vue?vue&type=template&id=52935922"
import script from "./SurveyFilters.vue?vue&type=script&lang=js"
export * from "./SurveyFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__